/**
 * @file NoticeScreen.tsx
 *
 * Minimal notice used by the shop bootstrap's terminal states (plan not eligible,
 * shop error). A title, a body, and an optional action button, styled inline to
 * match the app's lightweight presentation (no design system here yet). It fills
 * the app shell's content area below the top bar (see {@link AppShell}) and
 * centers its message.
 */

import type { ReactNode } from 'react';

export interface NoticeScreenProps {
  title: ReactNode;
  body?: ReactNode;
  action?: { label: ReactNode; onClick: () => void };
  /** ARIA role for the container; `alert` for errors, `status` otherwise. */
  role?: 'alert' | 'status';
}

export function NoticeScreen({
  title,
  body,
  action,
  role = 'status',
}: NoticeScreenProps) {
  return (
    <main
      role={role}
      style={{
        fontFamily: 'system-ui, sans-serif',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1 style={{ margin: 0 }}>{title}</h1>
      {body && (
        <p style={{ margin: 0, maxWidth: '32rem', color: '#555' }}>{body}</p>
      )}
      {action && (
        <button type="button" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </main>
  );
}
